import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e4f4e92")

_pushScopeId("data-v-3e4f4e92")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full text-white col-start-3 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "md:mx-4 lg:mx-12 flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
const _hoisted_5 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_List = _resolveComponent("List")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", null, [
            (_ctx.orderListData && _ctx.orders)
              ? (_openBlock(), _createBlock(_component_List, {
                  key: 0,
                  onPaginatePage: _ctx.loadData,
                  "list-data": _ctx.orderListData,
                  "pagination-data": _ctx.orderPagination
                }, null, 8, ["onPaginatePage", "list-data", "pagination-data"]))
              : (_openBlock(), _createBlock("h1", _hoisted_5, "hey du hast noch kein Boostpack abonniert... versuchs doch mal :)"))
          ])
        ])
      ])
    ])
  ]))
})